import Http from '@/utils/request'
import type {
  DistributeFeedResponse,
  FetchDistributeFeedParams,
  RetResult,
} from './type'

/**
 * 获取发现流分页数据
 * @param params 分页参数
 * @returns 发现流响应
 */
export function fetchDistributeFeed(
  params: FetchDistributeFeedParams = {},
): Promise<DistributeFeedResponse> {
  return Http({
    url: '/distribute/feed',
    method: 'get',
    params: {
      pageNo: params.pageNo ?? 1,
      ...(params.clientUniqueId !== undefined ? { clientUniqueId: params.clientUniqueId } : {}),
      ...(params.distributeType !== undefined ? { distributeType: params.distributeType } : {}),
      ...(params.bindUserId !== undefined ? { bindUserId: params.bindUserId } : {}),
    },
  })
}

/**
 * 点赞或取消点赞发现流内容
 * @param id 作品 id
 * @param liked 是否点赞
 * @returns 通用响应结果
 */
export function setDistributeWorkLiked(id: string, liked: boolean): Promise<RetResult> {
  const action = liked ? 'dolike' : 'unlike'

  return Http({
    url: `/work/${action}/${encodeURIComponent(id)}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export type {
  AnchorDetailDTO,
  AlbumUserDTO,
  CartoonBaseDTO,
  CollectionInfoDTO,
  DistributeFeedItem,
  DistributeFeedResponse,
  FeedBoxMaterial,
  FetchDistributeFeedParams,
  RetResult,
} from './type'
